import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Input,
  Button,
  InputNumber,
} from "antd";
const { Option } = Select;

const Variations = ({
  variations,
  barcodelist,
  reload,
  setreload,
  loading,
}) => {
  const [selectedvariation, setselectedvariation] = useState([]);
  const qty = useRef(0);
  const onfinish = () => {
    barcodelist.current.push({
      variation: selectedvariation,
      Quantity: qty.current,
    });
    setreload(!reload);
  };
  if (loading) {
    return "Loading...";
  } else
    return (
      <>
        <Col span={6}>
          <h3>Variation</h3>
          <Select
            style={{ width: "100%" }}
            placeholder="Variations"
            onChange={(value) => {
              setselectedvariation(variations.find((o) => o.id === value));
              // qty.current = variations.find((o) => o.id === value).quantity;
            }}
          >
            {variations.map((variation) => {
              return (
                <Option value={variation.id}>
                  {variation.Warehouse_name} - {variation.Attribute_details} -{" "}
                  {variation.quantity}
                </Option>
              );
            })}
          </Select>
        </Col>
        <Col span={4}>
          <h3>Amount</h3>
          <InputNumber
            // value={qty.current}
            min="1"
            max={selectedvariation.quantity}
            // ref={qty}
            onChange={(value) => {
              // alert(value);
              qty.current = value;
            }}
            placeholder="Please enter amount"
          />
        </Col>
        <Col span={2}>
          <h3 style={{ color: "white" }}>.</h3>
          <Button type="primary" onClick={onfinish}>
            Add
          </Button>
        </Col>
      </>
    );
};

export default connect(null, {})(Variations);
